var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.14453,
    y: 0.833008,
    width: 26.8556,
    height: 24.9112,
    rx: 4.67085,
    fill: "#43424A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.14453,
    y: 0.833008,
    width: 26.8556,
    height: 24.9112,
    rx: 4.67085,
    stroke: "#141518",
    strokeWidth: 0.778475
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50826 12.156C10.0382 9.78338 12.1423 8.09709 14.5706 8.09888C14.9504 8.0984 15.329 8.1412 15.6992 8.22646C17.0477 8.52329 18.2218 9.3474 18.9602 10.5154C19.6987 11.6835 19.9402 13.0985 19.6311 14.4458C19.6042 14.5953 19.4962 14.7171 19.3511 14.7616C19.2061 14.8061 19.0484 14.7657 18.9426 14.6569C18.8367 14.5482 18.8003 14.3894 18.8484 14.2453C19.334 12.0737 18.1102 9.88399 16.0075 9.16249C13.9048 8.44098 11.5967 9.41873 10.6497 11.4321C9.70277 13.4454 10.4203 15.8496 12.3152 17.0129C14.2101 18.1761 16.6757 17.7258 18.0383 15.9676C18.1847 15.832 18.408 15.8232 18.5645 15.947C18.7211 16.0708 18.7643 16.2903 18.6664 16.4643C17.1804 18.3871 14.5602 19.0194 12.3624 17.9855C10.1646 16.9516 8.97834 14.5286 9.50826 12.156ZM14.6415 14.5433C14.5522 14.355 14.62 14.1296 14.7984 14.022L15.1033 13.8716L15.613 12.2405L14.0202 12.7417L13.292 15.0699C13.2265 15.2812 13.0025 15.3994 12.7914 15.3342C12.6891 15.3028 12.6035 15.2316 12.5539 15.1365C12.5043 15.0415 12.4948 14.9306 12.5275 14.8284L13.3193 12.2951C13.3604 12.171 13.4586 12.0743 13.5833 12.0354L16.1136 11.2426C16.1901 11.2152 16.2737 11.2152 16.3502 11.2426C16.4523 11.2731 16.5378 11.3434 16.5875 11.4377C16.6371 11.532 16.6467 11.6423 16.6142 11.7438L15.8041 14.2817C15.7719 14.3869 15.6978 14.4742 15.5993 14.5232L15.1442 14.751C14.9483 14.8214 14.7309 14.7316 14.6415 14.5433Z",
    fill: "#F7F7F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBtnIcon);
export default __webpack_public_path__ + "static/media/LinkBtnIcon.4c878ea3c3a0d81ee1891aa4d7ac1528.svg";
export { ForwardRef as ReactComponent };